// use own file for root reducer, otherwise tests will fail with the additional code from redux-persist and redux-saga
import { combineReducers } from 'redux'
import { submitFormReducer as form } from 'components/submitForm'
import { questionsReducer as selectedAnswers } from 'components/questions'
import {
  completenessReducer as isComplete,
  submissionStatusReducer as submissionStatus
} from 'components/main'
import { firebaseReducer as firebase } from 'stores/firebase'

export const rootReducer = combineReducers({
  form,
  selectedAnswers,
  submissionStatus,
  isComplete,
  firebase
})
